import React from "react";
import blank from "../../images/blank.jpg";
import { Link } from "react-router-dom";
import { domain } from "../../ajax/Ajax";
import parseDistance from "../../utils";

class Product extends React.Component {
  render() {
    let product = null;

    if (this.props.product) {
      product = this.props.product;
    }
    return (
      <div className="item">
        <div className="card bordered-card is-shadowless">
          <Link
            to={
              this.props.shop
                ? {
                    pathname:
                      "/shop-at/" +
                      product.shop.name.replace(/\s+/g, "-") +
                      "/" +
                      product.shop.id +
                      "/product/?pid=" +
                      product.item.id,
                    state: {
                      product: product,
                    },
                  }
                : {
                    pathname: "/market/product/?pid=" + product.item.id,
                    state: {
                      product: product,
                    },
                  }
            }
          >
            <div
              title="Select to learn more"
              className="card-image static-link product-image"
            >
              <figure className="image">
                <img
                  src={product.item.image ? domain + product.item.image : blank}
                  alt=""
                />
              </figure>
            </div>
          </Link>
          <div className="card-content">
            <p className="has-text-left product-name ellipsis">
              <strong>{product.item.name}</strong>
            </p>
            <div className="d-flex justify-content-between price-and-stock-field">
              <span className="has-text-info has-text-weight-bold">
                <span>{product.shop.currency}</span>{" "}
                {product.item.price.toLocaleString()}
              </span>
              <span className="has-text-info">
                {product.item.stock > 10 ? (
                  <strong>
                    <small className="has-text-success">Available</small>
                  </strong>
                ) : (
                  <strong>
                    <small className="has-text-danger">Limited</small>
                  </strong>
                )}
                <span> </span>
              </span>
            </div>
            {!this.props.shop ? (
              <div className="mt-2 ellipsis">
                <Link
                  to={{
                    pathname: `/shop-at/${product.shop.name.replace(
                      /\s+/g,
                      "-"
                    )}/${product.shop.id}/`,
                    state: {
                      shop: product.shop,
                    },
                  }}
                >
                  {product.shop.name}
                </Link>
                <div>
                  <small>
                    <p className="ellipsis">
                      {product.shop.address} ({product.shop.phone})
                    </p>
                  </small>
                </div>
                <div>
                  <small>
                    <strong>
                      {product.shop.distance ? (
                        <span>~{parseDistance(product.shop.distance)}</span>
                      ) : (
                        <span>Unknown distance</span>
                      )}{" "}
                      from you
                    </strong>
                  </small>
                </div>
              </div>
            ) : (
              <div></div>
            )}

            <div className="order-btns d-flex justify-content-between pt-2">
              <div>
                <Link
                  to={
                    this.props.shop
                      ? {
                          pathname:
                            "/shop-at/" +
                            product.shop.name.replace(/\s+/g, "-") +
                            "/" +
                            product.shop.id +
                            "/cart/add/?pid=" +
                            product.item.id,
                          state: {
                            product: product,
                          },
                        }
                      : {
                          pathname: "/market/cart/add/?pid=" + product.item.id,
                          state: {
                            product: product,
                          },
                        }
                  }
                >
                  <button
                    title="Add to Cart"
                    className="button is-small is-outlined is-info"
                  >
                    <span className="zmdi zmdi-shopping-cart-add mr-1"></span>
                    Add
                  </button>
                </Link>
              </div>
              <div>
                <Link
                  to={
                    this.props.shop
                      ? {
                          pathname:
                            "/shop-at/" +
                            product.shop.name.replace(/\s+/g, "-") +
                            "/" +
                            product.shop.id +
                            "/order/?pid=" +
                            product.item.id,
                          state: {
                            product: product,
                          },
                        }
                      : {
                          pathname: "/market/order/?pid=" + product.item.id,
                          state: {
                            product: product,
                          },
                        }
                  }
                >
                  <button
                    title="Place Order to Shop"
                    className="button is-small is-outlined is-primary"
                  >
                    <span className="zmdi zmdi-money mr-1"></span>
                    Order
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Product;
